// third-party
import { IconListCheck, IconMap2, IconDirections, IconMapPins, IconVaccine } from '@tabler/icons-react';
import { FormattedMessage } from 'react-intl';

const icons = {
    IconListCheck,
    IconMap2,
    IconMapPins,
    IconDirections,
    IconVaccine
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const formManagement = {
    id: 'Form Management',
    title: <FormattedMessage id="Form Management" />,
    icon: icons.IconListCheck,
    type: 'group',
    children: [
        {
            id: 'Form Configuration',
            title: <FormattedMessage id="Form Configuration" />,
            type: 'item',
            url: '/form-configuration',
            icon: icons.IconListCheck,
            breadcrumbs: false
        },
        {
            id: 'Region Configuration',
            title: <FormattedMessage id="Region Configuration" />,
            type: 'item',
            url: '/region-configuration',
            icon: icons.IconMapPins,
            breadcrumbs: false
        },
        {
            id: 'States/Exports Configuration',
            title: <FormattedMessage id="State/Export Configuration" />,
            type: 'item',
            url: '/state-configuration',
            icon: icons.IconMap2,
            breadcrumbs: false
        },
        {
            id: 'District Configuration',
            title: <FormattedMessage id="District Configuration" />,
            type: 'item',
            url: '/district-configuration',
            icon: icons.IconDirections,
            breadcrumbs: false
        },
        {
            id: 'Anticoccidial Configuration',
            title: <FormattedMessage id="Anticoccidial Configuration" />,
            type: 'item',
            url: '/anticoccidial-configuration',
            icon: icons.IconVaccine,
            breadcrumbs: false
        },
    ]
};

export default formManagement;